module.exports = __webpack_public_path__ + "img/sjhz.ec26e6a5.png";